import { type MenuLink } from "core-fe-lib/components-shadcn/types/menu-link";

export function getAIEmployeeLinks(t: any): MenuLink[] {
  return [
    {
      title: t("layout.navigation.aiemployee.employees.title"),
      caption: t("layout.navigation.aiemployee.employees.caption"),
      icon: "badge",
      hasExpansion: true,
      items: [
        {
          title: t("layout.navigation.aiemployee.dashboard.title"),
          caption: t("layout.navigation.aiemployee.dashboard.caption"),
          icon: "insights",
          link: "/aiemployee/dashboard",
        },
      ],
    },
  ];
}
